import attachmentContext from "./attachmentContext"
import entity from "./entity"
import notifications from "./notifications"
import others from "./others"
import permissionNotifications from "./permissionNotifications"
import time from "./time"
import filter from "./filter"

export default {
  attachmentContext,
  entity,
  notifications,
  others,
  permissionNotifications,
  time,
  filter,
}
